module.exports = __webpack_public_path__ + "static/media/animation.78bc202e.gif";